var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveChat43A0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51.823,
    height: 50.707,
    viewBox: "0 0 51.823 50.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.962,
    y1: 0.5,
    x2: 0,
    y2: 0.782,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f47341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#803d23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10272d"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_511-2",
    x: 0,
    y: 0,
    width: 51.823,
    height: 50.707,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.322
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1375",
    "data-name": "Group 1375",
    transform: "translate(15.258 12.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(6.35 4.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_511-2-2",
    "data-name": "Path 511-2",
    d: "M21.525,20.5l-2.076-3.616A8.7,8.7,0,1,0,5.4,18.825c.077.082.155.163.235.241a8.71,8.71,0,0,0,10.247,1.441c.032.012,5.294.537,5.294.537h.035a.365.365,0,0,0,.315-.541Z",
    transform: "translate(-3.041 -4.183)",
    fill: "#fe7641"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_110-2",
    "data-name": "Group 110",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15.26, -12.25)",
    filter: "url(#Path_511-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_511-2-3",
    "data-name": "Path 511-2",
    d: "M3.093,22.954,5.482,18.8a10.008,10.008,0,1,1,16.161,2.228c-.088.094-.179.187-.271.278A10.018,10.018,0,0,1,9.586,22.959c-.037.014-6.09.617-6.09.617H3.456a.42.42,0,0,1-.362-.622Z",
    transform: "translate(12.22 8.07)",
    stroke: "rgba(204,214,246,0.5)",
    strokeWidth: 0.5,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 1.523,
    cy: 1.538,
    rx: 1.523,
    ry: 1.538,
    transform: "translate(4.938 9.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538,
    transform: "translate(9.522 9.203)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538,
    transform: "translate(14.135 9.203)",
    fill: "#fff",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChat43A0);
export default __webpack_public_path__ + "static/media/live-chat43a0.63b12776d52672b9002acfb6bea10578.svg";
export { ForwardRef as ReactComponent };